import { Injectable } from '@angular/core';

import {
   HttpInterceptor,
   HttpRequest,
   HttpHandler,
   HttpEvent,
   HttpResponse,
   HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpPagination } from './http-pagination';
import { Pagination } from './response.wrapper';

@Injectable()
export class PaginationHttpInterceptor implements HttpInterceptor {
   constructor( private pagination: HttpPagination ) {}

   intercept(
      request: HttpRequest<any>,
      next: HttpHandler,
   ): Observable<HttpEvent<any>> {

      return next.handle( request ).pipe(
         tap( result => {
            if ( !( result instanceof HttpResponse )) { return; }

            const p: Pagination = result?.body?.response?.pagination;

            if ( !p ) { return this.pagination.hide(); } // bail, but only hide if there is nothing in the works

            if ( !this.pagination.hash && p.page !== 1 ) { return; } // cancelled request

            if ( p.page === 1 ) { this.pagination.hash = p.hash; } // start it up

            if ( p.page >= p.total ) { return this.pagination.reset(); } // we're done here

            this.pagination.loading = true;
            this.pagination.loadingPercent = +( p.page / p.total * 100 ).toFixed();
         }),
      );
   }
}

export let paginationHttpInterceptor = {
   provide: HTTP_INTERCEPTORS,
   useClass: PaginationHttpInterceptor,
   multi: true
};
